var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEquifax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 21,
    viewBox: "0 0 101 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_696_893)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.869 3.67511L16.5042 0.640137H3.35906L1.6175 8.98632L0.138672 15.7076H13.6528L14.3389 12.5101H6.84308L7.52918 9.25759H13.8638L14.5499 6.22447H8.21573L8.74391 3.67835L15.869 3.67511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9027 9.25764H31.493C31.7323 8.05773 31.9083 6.84558 32.0203 5.62641C32.088 5.00275 31.9677 4.37282 31.6753 3.82076C31.383 3.2687 30.9324 2.82078 30.384 2.53681C28.7019 1.57947 26.2229 1.62993 24.3661 1.56142C21.82 1.46883 18.7907 1.80353 17.1871 4.10754C16.3598 5.29681 15.8943 7.13881 15.7114 8.57945C15.4845 10.3386 14.6224 13.2861 16.1842 14.7304C17.3459 15.8063 19.9451 16.1655 21.4561 16.1423C22.9815 16.1414 24.5035 15.9956 26.0024 15.7067L29.9611 20.6393H36.1395L26.9027 9.25764ZM26.2161 9.36596C25.7111 11.7028 25.0232 13.6684 22.3627 13.6481C19.6914 13.6268 20.5776 10.6955 20.8322 8.98683C21.192 6.55968 22.1054 4.01402 24.8439 4.21864C27.6155 4.42325 26.6377 7.42351 26.2157 9.36596H26.2161ZM51.5545 2.32062L50.1292 8.98683L48.7039 15.7081H54.0888L56.9929 2.32062H51.5545ZM70.1884 4.97646L70.8237 2.32062H59.0498L56.1992 15.7081H61.6367L62.851 9.96268H68.1823L68.3933 8.98683L68.7109 7.46887H63.4309L63.9591 4.97646H70.188H70.1884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2392 2.32055H39.7298L37.6697 11.8055C37.4183 12.9629 38.4783 13.5698 39.3872 13.6513C39.9607 13.7053 40.5335 13.5415 40.9959 13.1912C41.4583 12.841 41.7777 12.3289 41.8929 11.7532L44.0574 2.32287H49.4944L47.3299 12.3495C46.4033 14.9637 44.2566 15.9904 41.8847 16.2464C40.4061 16.3754 38.9172 16.3041 37.4569 16.0344L32.6016 10.0728L34.2392 2.32055ZM82.3816 2.32055H89.2961L91.4075 5.78929L94.8384 2.32055H100.118L93.2031 8.55299L97.7407 15.7076H90.9851L88.7684 11.6421L84.9681 15.7076H76.891L76.5734 12.7805H70.9794L69.0254 15.7076H65.2251L74.4103 2.32009H81.009L82.2754 13.1592L86.6561 9.03907L82.3807 2.31824L82.3816 2.32055ZM72.774 9.90799L75.7299 5.35507L76.258 9.90799H72.7745H72.774Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_696_893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99.9799,
    height: 20,
    fill: "white",
    transform: "translate(0.138672 0.640137)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquifax);
export default __webpack_public_path__ + "static/media/equifax.07a6672184c60b6f8e4c3347638eed4d.svg";
export { ForwardRef as ReactComponent };